module Meevo.Components.LocationPicker {

    export interface ILocationPickerService {
        switchLocation: (locationId: number) => void;
    }

    export class LocationPickerService implements ILocationPickerService {
        private functionIsRunning = false;

        constructor(
            private $window: angular.IWindowService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private busyService: Meevo.Components.Busy.IBusyService) {
        }


        public switchLocation(locationId: number) {
            this.busyService.start();
            if (this.functionIsRunning) {
                console.log('Multiple Attempts to ChangeLocation LocationId', locationId);
                console.log('Multiple Attempts to ChangeLocation TenantId ', this.$window.location.search.split('tenantId=')[1]);
                return;
            }

            this.functionIsRunning = true;

            sessionStorage.setItem(Components.Common.Constants.SS_LOCATION_OVERRIDE, JSON.stringify(location));
            var tenantId = this.$window.location.search.split('tenantId=')[1];
            let request = { "locationId": locationId };
            var parms = '?tenantId=' + tenantId;
            this.dataService.patch(this.appSettings.API_ENDPOINTS.session, request)
            .then((response) => {
                const url = this.appSettings.APP_URL + parms;
                if (response.bearerToken) {
                    sessionStorage.setItem('mil:meevo:token', response.bearerToken);
                }
                this.busyService.stop();
                this.$window.location.href = url;
            }).finally(() => {
                this.busyService.stop();
            });
        }

        static factory(): Function {
            let svc = (
                $window: angular.IWindowService,
                appSettings: Meevo.Components.Common.IAppSettings,
                dataService: Meevo.Components.BaseClasses.IDataService,
                busyService: Meevo.Components.Busy.IBusyService) => {
                return new LocationPickerService($window, appSettings, dataService, busyService);
            }

            svc.$inject = [
                "$window",
                "meevo.AppSettings",
                "meevo.components.common.DataService",
                "meevo.components.busy.BusyService"
            ];

            return svc;
        }
    }

    angular.module("meevo.components.locationPicker")
        .factory("meevo.components.locationPicker.LocationPickerService", LocationPickerService.factory());
}

